import React, { useState, useEffect, useRef, useMemo } from "react";
import "./Styles.css";
import moment from "moment";
import { Api, FileUpload, RecommendSchemesApi } from "../../Api";
import Voice from "../Voice/Voice";
import {
  Translation,
  Hospitals,
  OptionSelect,
  HospitalHeader,
  audio,
  shortAudio,
  ListeningTrans,
  fileLimt,
  fileLimtWar,
} from "../../Translation/index";
import MicAndTextfield from "../MicAndTextfield/MicAndTextfield";
import Messages from "./Messages";
import LanguageOptions from "./LanguageOptions";
import SchemesOptions from "./SchemesOptions";
import AutoSuggestions from "./AutoSuggestions";
import HospitalOptions from "./HospitalOptions";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import useRecorder from "./recorder/useRecorder";
import { schemeData } from "../../Utils/Data";
import Fuse from "fuse.js";
import { buttonConfigs } from "../../Config/ButtonConfig";
import DebugLogger from "../DebugLogger/DebugLogger";
const searchParams = new URLSearchParams(document.location.search);
const language = searchParams.get("locale") ? searchParams.get("locale") : "en";

const ChatContent = (props: any) => {
  const { Lang, appModulesData } = props;
  const chatMessageRef = useRef<HTMLDivElement | null>(null);
  const redirectionUrlRef = useRef<string | null>(null);
  const [hideInput, setHideInput] = useState(false);
  const [autoPlay, setAutoPlay] = useState<boolean>(false);
  const [optionList, setOptionList] = useState<any>([]);
  const [input, setInput] = useState<any>("");
  const [selectedLanguage, setSelectedLanguage] = useState<string>(language);
  const audioElementRef = useRef(null);
  const [currentAudioUrl, setCurrentAudioUrl] = useState<string | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  /** When set, audio autoplay was blocked (e.g. no user gesture); show in UI and console */
  const [audioPlayFailed, setAudioPlayFailed] = useState<string | null>(null);
  const isGreetingAudioRef = useRef(false);
  const shouldAutoMicAfterAudioRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [voiceRecognition, setVoiceRecognition] = useState<boolean>(false);
  const [inputField, setInputField] = useState<boolean>(true);
  const [fileUpload, setFileUpload] = useState(false);
  const [location, setLocation] = useState(false);
  const [micBtn, setMicBtn] = useState(true);
  const [sendBtn, setSendBtn] = useState(false);
  const [active, setActive] = useState(false);
  const [languageOptions, setLanguageOptions] = useState(false);
  const translations = JSON.parse(JSON.stringify(Translation));
  const [isEnded, setIsEnded] = useState(false);
  const [HospitalView, setHospitalView] = useState(false);
  const [HospitalData, setHospitalData] = useState({});
  const [backOptions, setBackOptions] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [transcriptTxt, setTranscriptTxt] = useState<any>("");
  const [renderMic, setRenderMic] = useState(true);
  const [autoInput, setAutoInput] = useState(true);
  const [autoSuggScheme, setAutoSuggScheme] = useState([]);
  const [originalServiceList, setOriginalServiceList] = useState<any>([]);
  const [selectedServiceCategory, setSelectedServiceCategory] = useState<any>(null);
  const [isJobsContext, setIsJobsContext] = useState<boolean>(false);
  const isJobsContextRef = useRef<boolean>(false);
  const [serviceNextContext, setServiceNextContext] = useState<string | null>(null);
  const serviceNextContextRef = useRef<string | null>(null);
  const [isAssameseRecording, setIsAssameseRecording] = useState<boolean>(false);
  const assameseRecordingRef = useRef<boolean>(false);
  const silenceDetectionRef = useRef<any>(null);
  const loadingRef = useRef<boolean>(false);
  const lastProcessedTranscriptRef = useRef<string>(""); // Track last processed transcript to prevent reuse

  const recorder = useRecorder((audioDataUrl) => {
    console.log('🎬 [ChatContent] Recorder onBlob callback triggered');
    console.log('🎬 [ChatContent] Audio data URL length:', audioDataUrl?.toString().length);
    console.log('🎬 [ChatContent] Audio data prefix:', audioDataUrl?.toString().substring(0, 50));
    console.log('🎬 [ChatContent] Loading ref state:', loadingRef.current);

    // Send base64 audio to API only for iOS and Assamese (as); other browsers use transcript
    if (loadingRef.current) {
      console.log('⚠️ [ChatContent] Already loading, skipping API call');
      return;
    }

    console.log('🚀 [ChatContent] Calling API with audio data, inputType: voice');
    apiCall(audioDataUrl, false, "voice");
    setLoading(true);
    loadingRef.current = true;
    console.log('✅ [ChatContent] Loading state set to true');
  });

  const [optionHeader, SetOptionsHeader] = useState(
    (OptionSelect as any)[selectedLanguage]
  );

  const { transcript, listening, resetTranscript } = useSpeechRecognition();

  // Build options from button configuration with URL parameter support
  const buildOptionsFromConfig = (language: string) => {
    const searchParams = new URLSearchParams(document.location.search);
    const hideButtonsParam = searchParams.get("hideButtons");
    const buttonOrderParam = searchParams.get("buttonOrder");
    const maxButtonsParam = searchParams.get("maxButtons");
    const buttonLabelsParam = searchParams.get("buttonLabels");

    // Parse hideButtons parameter (comma-separated list)
    const hideButtonsList = hideButtonsParam
      ? hideButtonsParam.split(",").map(id => id.trim())
      : [];

    // Parse buttonOrder parameter (comma-separated list)
    const buttonOrderList = buttonOrderParam
      ? buttonOrderParam.split(",").map(id => id.trim())
      : null;

    // Parse buttonLabels parameter
    // Supports two formats:
    // 1. Simple format: "111|Submit a Grievance,112|Find Hospitals" (pipe delimiter, no encoding needed)
    // 2. Original format: "111:Submit%20a%20Grievance" (colon delimiter, URL encoded)
    const customLabels: Record<string, string> = {};
    if (buttonLabelsParam) {
      buttonLabelsParam.split(",").forEach((pair) => {
        const trimmedPair = pair.trim();
        let buttonId: string, label: string;

        // Check if using pipe delimiter (simpler format)
        if (trimmedPair.includes("|")) {
          [buttonId, label] = trimmedPair.split("|").map(s => s.trim());
        } else {
          // Use colon delimiter (original format with URL encoding)
          [buttonId, label] = trimmedPair.split(":").map(s => s.trim());
          // Decode URL-encoded labels (handles spaces, special chars)
          label = decodeURIComponent(label);
        }

        if (buttonId && label) {
          customLabels[buttonId] = label;
        }
      });
    }

    // Use API data if available, otherwise fall back to config
    if (appModulesData && appModulesData[language] && Array.isArray(appModulesData[language])) {
      // Mapping: API array index -> Button ID
      // Index 0 -> 110, Index 1 -> 111, Index 2 -> 112, Index 3 -> 113, Index 4 -> 114, Index 5 -> 115, Index 6 -> 116
      const buttonIdMapping = ["110", "111", "112", "113", "114", "115", "116"];
      const apiLabels = appModulesData[language];

      // Build buttons from API response in the order they appear
      const buttonsFromApi = apiLabels
        .map((label: string, index: number) => ({
          id: buttonIdMapping[index],
          label: label,
          order: index,
        }))
        .filter((btn: any) => {
          // Check if button exists in config and is enabled
          const configBtn = buttonConfigs.find(b => b.id === btn.id);
          return configBtn && configBtn.enabled && !hideButtonsList.includes(btn.id);
        });

      // Apply custom order if specified in URL
      let orderedButtons = buttonsFromApi;
      if (buttonOrderList && buttonOrderList.length > 0) {
        orderedButtons = buttonsFromApi.sort((a, b) => {
          const indexA = buttonOrderList.indexOf(a.id);
          const indexB = buttonOrderList.indexOf(b.id);
          const orderA = indexA !== -1 ? indexA : 999;
          const orderB = indexB !== -1 ? indexB : 999;
          return orderA - orderB;
        });
      } else {
        // Use API order (already in correct order)
        orderedButtons = buttonsFromApi.sort((a, b) => a.order - b.order);
      }

      // Parse maxButtons parameter - if not provided, show all API buttons
      let maxButtons = orderedButtons.length; // Default to all buttons when using API data
      if (maxButtonsParam) {
        const parsed = parseInt(maxButtonsParam, 10);
        if (!isNaN(parsed) && parsed > 0) {
          maxButtons = parsed;
        }
      }

      // Limit to maxButtons only if explicitly set in URL
      if (maxButtonsParam) {
        orderedButtons = orderedButtons.slice(0, maxButtons);
      }

      return orderedButtons.map((btn) => ({
        id: btn.id,
        // Use custom label if provided, otherwise use API label
        val: customLabels[btn.id] || btn.label,
      }));
    }

    // Fallback to original logic if API data is not available
    // Parse maxButtons parameter (default to 3 if not provided, only for fallback)
    let maxButtons = 3; // default for fallback
    if (maxButtonsParam) {
      const parsed = parseInt(maxButtonsParam, 10);
      if (!isNaN(parsed) && parsed > 0) {
        maxButtons = parsed;
      }
    }

    let filteredButtons = buttonConfigs
      .filter((btn) => btn.enabled) // Only enabled buttons from config
      .filter((btn) => !hideButtonsList.includes(btn.id)); // Apply URL blacklist

    // Apply custom order if specified in URL
    if (buttonOrderList && buttonOrderList.length > 0) {
      filteredButtons = filteredButtons.sort((a, b) => {
        const indexA = buttonOrderList.indexOf(a.id);
        const indexB = buttonOrderList.indexOf(b.id);

        // If button not in order list, place it at the end
        const orderA = indexA !== -1 ? indexA : 999;
        const orderB = indexB !== -1 ? indexB : 999;

        return orderA - orderB;
      });
    } else {
      // Use default order from config
      filteredButtons = filteredButtons.sort((a, b) => a.order - b.order);
    }

    // Limit to maxButtons (default 3, or value from URL parameter)
    // slice will automatically handle cases where maxButtons > available buttons
    filteredButtons = filteredButtons.slice(0, maxButtons);

    return filteredButtons.map((btn) => ({
      id: btn.id,
      // Use custom label if provided, otherwise use translation
      val: customLabels[btn.id] || translations[language][btn.translationKey],
    }));
  };

  // Recalculate schemeOptions when language or API data changes
  // Note: URL parameters are read directly from document.location.search in the function
  const schemeOptions = useMemo(() => {
    return buildOptionsFromConfig(selectedLanguage);
  }, [selectedLanguage, appModulesData]);

  // const { sendQuerydata, sendQueryError, fetchData } = useSendQueryApi();
  const [messages, setMessages] = useState<any>([]);
  const isIOS = () => {
    const platform = window.navigator.platform.toLowerCase();
    console.log('IOS Platform check', { platform });
    // Check for iOS devices (iPhone, iPad, iPod) or Mac
    // Applies to ALL languages for consistent behavior
    return platform.includes("mac") || platform.startsWith("ip");
  };

  // Setup silence detection using Web Audio API
  // silenceDurationMs: e.g. 3000 for Assamese, 5000 for iOS
  const setupSilenceDetection = async (silenceDurationMs: number = 3000) => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      const analyser = audioContext.createAnalyser();
      const microphone = audioContext.createMediaStreamSource(stream);
      const dataArray = new Uint8Array(analyser.frequencyBinCount);

      microphone.connect(analyser);
      analyser.fftSize = 2048;
      analyser.smoothingTimeConstant = 0.8;

      let silenceStart = Date.now();
      const SILENCE_THRESHOLD = 10; // Increased threshold for better detection
      const SILENCE_DURATION = silenceDurationMs;
      let animationFrameId: number | null = null;

      const detectSilence = () => {
        // Check if still recording using ref (to avoid closure issues)
        if (!assameseRecordingRef.current) {
          // Cleanup when recording stops manually
          if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
          }
          stream.getTracks().forEach(track => track.stop());
          if (audioContext.state !== 'closed') {
            audioContext.close();
          }
          return;
        }

        analyser.getByteTimeDomainData(dataArray);

        // Calculate volume level (RMS - Root Mean Square)
        let sum = 0;
        for (let i = 0; i < dataArray.length; i++) {
          const normalized = (dataArray[i] - 128) / 128;
          sum += normalized * normalized;
        }
        const rms = Math.sqrt(sum / dataArray.length);
        const volume = rms * 100; // Convert to percentage

        // Only log occasionally to reduce console spam
        if (Math.random() < 0.1) {
          console.log('Volume level:', volume.toFixed(2));
        }

        if (volume < SILENCE_THRESHOLD) {
          // Silence detected
          const silenceDuration = Date.now() - silenceStart;

          if (silenceDuration > SILENCE_DURATION) {
            // console.log('✅ Auto-stopping due to 3 seconds of silence');
            // Cancel animation frame first
            if (animationFrameId) {
              cancelAnimationFrame(animationFrameId);
            }
            // Call stopRecognition which will handle cleanup via the cleanup ref
            stopRecognition();
            return;
          }
        } else {
          // Sound detected, reset silence timer
          silenceStart = Date.now();
        }

        // Continue checking
        animationFrameId = requestAnimationFrame(detectSilence);
      };

      // Store detection refs for cleanup
      silenceDetectionRef.current = {
        stream,
        audioContext,
        animationFrameId: () => animationFrameId,
        cleanup: () => {
          if (animationFrameId !== null) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = null;
          }
          stream.getTracks().forEach(track => track.stop());
          if (audioContext.state !== 'closed') {
            audioContext.close();
          }
        }
      };

      detectSilence();
    } catch (error) {
      console.error("Error setting up silence detection:", error);
    }
  };

  const requestPermission = async () => {
   console.log('🎛 [ChatContent] requestPermission called. Current voiceRecognition:', voiceRecognition);
    // console.log('🎭 [ChatContent] requestPermission called (main mic)');
    // console.log('🎭 [ChatContent] About to request mic. If permission denied, check Flutter/native app mic permission.');
    try {
      startRecognition();
      // Recording is now started in startRecognition for all platforms
    } catch (error) {
      console.error("❌ [ChatContent] Permission denied:", error);
      alert("Error: " + error);
    }
  };
  const startRecognition = () => {
    console.log("🎙️ [ChatContent] startRecognition called", {
      voiceRecognition,
      selectedLanguage,
      isIOS: isIOS(),
    });
    // console.log('\n========================================');
    // console.log('🎙️ [ChatContent] START RECOGNITION CALLED (MAIN MIC)');
    // console.log('========================================');
    // console.log('🎙️ [ChatContent] Platform:', window.navigator.platform);
    // console.log('🎙️ [ChatContent] User Agent:', window.navigator.userAgent);
    // console.log('🎙️ [ChatContent] Selected Language:', selectedLanguage);
    // console.log('🎙️ [ChatContent] isIOS():', isIOS());
    // console.log('🎙️ [ChatContent] navigator.mediaDevices:', !!navigator.mediaDevices, '(required for mic from Flutter WebView)');
    // console.log('========================================\n');

    playAudio(
      "https://coroverbackendstorage.blob.core.windows.net/chatbot-audio-bucket/start.mp3"
    );
    pauseAudio();

    // Clear any previous transcript BEFORE starting a new recognition cycle
    // console.log(
    //   "🧹 [ChatContent] Clearing transcript BEFORE start. Current values:",
    //   { transcript, lastProcessedTranscript: lastProcessedTranscriptRef.current }
    // );
    try {
      resetTranscript();
    } catch (err) {
      console.error(
        "❌ [ChatContent] Error calling resetTranscript() in startRecognition:",
        err
      );
    }
    lastProcessedTranscriptRef.current = "";
    setTranscriptTxt("");
    // console.log(
    //   "🧹 [ChatContent] Requested transcript reset in startRecognition. New ref values:",
    //   { lastProcessedTranscript: lastProcessedTranscriptRef.current }
    // );

    setVoiceRecognition(true);
    console.log('🎙️ [ChatContent] voiceRecognition set to true');

    // For Assamese on non-iOS devices, use recorder with silence detection
    if (selectedLanguage === 'as' && !isIOS()) {
      console.log('🎙️ [ChatContent] Assamese mode (non-iOS) - using recorder with silence detection');
      // console.log('🎙️ [ChatContent] Assamese mode (non-iOS) - using recorder with silence detection');
      // Set recording state to show popup
      setIsAssameseRecording(true);
      assameseRecordingRef.current = true; // Set ref for closure
      // console.log('🎙️ [ChatContent] Starting recorder for Assamese...');
      // Start recording directly without Speech Recognition
      recorder.startRecording();
      // Setup silence detection for auto-stop
      setupSilenceDetection();
      // console.log('🎙️ [ChatContent] Silence detection setup complete');
      return;
    }

    const iosDevice = isIOS();

    if (iosDevice) {
      // 🔹 iOS path: DO NOT use react-speech-recognition.
      // Recorder + silence detection: after 5 seconds of silence, stop and send base64.
      console.log('🎙️ [ChatContent] iOS detected - starting recorder for base64 audio (no SpeechRecognition)');
      setIsAssameseRecording(true);
      assameseRecordingRef.current = true;
      recorder.startRecording();
      console.log('✅ [ChatContent] recorder.startRecording() called from startRecognition (iOS)');
      // Delay silence detection so recorder's getUserMedia completes first (avoids two simultaneous mic requests on iOS)
      setTimeout(() => {
        if (assameseRecordingRef.current) {
          setupSilenceDetection(5000); // 5 seconds of silence then auto-stop and send
          console.log('🎙️ [ChatContent] iOS silence detection started (5s)');
        }
      }, 500);
    } else {
      // 🔹 Non-iOS path: use SpeechRecognition (transcript-only flow).
      // Map language codes for speech recognition
      // Assamese (as) is not supported by Chrome Speech Recognition API
      // Use Bengali (bn) as fallback since they are linguistically similar
      const speechRecognitionLanguageMap: Record<string, string> = {
        'as': 'bn', // Assamese -> Bengali (fallback)
      };

      // Get the appropriate language code for speech recognition
      const recognitionLanguage = speechRecognitionLanguageMap[selectedLanguage] || selectedLanguage;
      const speechRecLang = `${recognitionLanguage}-IN`;

      console.log('🗣️ [ChatContent] Starting SpeechRecognition.startListening with language:', speechRecLang);
      SpeechRecognition.startListening({
        continuous: false,
        language: speechRecLang,
      });
      // console.log('✅ [ChatContent] SpeechRecognition.startListening called');
    }
  };

  const stopRecognition = () => {
    console.log('⏹️ [ChatContent] stopRecognition called');
    // console.log('\n========================================');
    // console.log('⏹️ [ChatContent] STOP RECOGNITION CALLED');
    // console.log('========================================');
    // console.log('⏹️ [ChatContent] Selected Language:', selectedLanguage);
    // console.log('⏹️ [ChatContent] isIOS():', isIOS());
    // console.log('========================================\n');

    // For Assamese on non-iOS devices, only stop recorder
    if (selectedLanguage === 'as' || isIOS()) {
      console.log('inside for the IOS check');
      // console.log('🎙️ [ChatContent] Assamese mode - stopping recorder');
      // Cleanup silence detection
      if (silenceDetectionRef.current) {
        console.log('🔇 [ChatContent] Cleaning up silence detection');
        silenceDetectionRef.current.cleanup();
        silenceDetectionRef.current = null;
      }

      // Save recording FIRST before changing any state
      recorder.saveRecording();

      // Update state AFTER saveRecording is called (close popup, reset flags)
      setIsAssameseRecording(false);
      assameseRecordingRef.current = false;
      setVoiceRecognition(false);

      return;
    }

    // console.log('🗣️ [ChatContent] Calling SpeechRecognition.stopListening()');
    SpeechRecognition.stopListening();

    // Force-abort to fully terminate the session (helps iOS release resources)
    try {
      SpeechRecognition.abortListening();
      // console.log('🧹 [ChatContent] Aborted SpeechRecognition session completely');
    } catch (err) {
      console.warn('⚠️ [ChatContent] Error aborting session:', err);
    }

    // Clear transcript state when stopping (for main mic) so that
    // when we later open schemes mic or restart main mic we don't
    // accidentally reuse an old phrase.
    // console.log(
    //   "🧹 [ChatContent] Clearing transcript in stopRecognition. Current state:",
    //   { transcript, lastProcessedTranscript: lastProcessedTranscriptRef.current }
    // );
    try {
      resetTranscript();
      lastProcessedTranscriptRef.current = "";
      setTranscriptTxt("");
    } catch (err) {
      console.error(
        "❌ [ChatContent] Error calling resetTranscript() in stopRecognition:",
        err
      );
    }
    // console.log(
    //   "🧹 [ChatContent] Transcript cleared in stopRecognition. New ref values:",
    //   { lastProcessedTranscript: lastProcessedTranscriptRef.current }
    // );

    if (isIOS()) {
      // console.log('🎙️ [ChatContent] iOS - saving recorder');
      recorder.saveRecording();
    } else {
      // console.log('📝 [ChatContent] Non-iOS - using transcript only');
    }
  };

  const cancelRecognition = () => {
    // For Assamese on non-iOS, or iOS (both use recorder + optional silence detection)
    if (selectedLanguage === 'as' && !isIOS()) {
      if (silenceDetectionRef.current) {
        silenceDetectionRef.current.cleanup();
        silenceDetectionRef.current = null;
      }
      recorder.cancelRecording();
      setIsAssameseRecording(false);
      assameseRecordingRef.current = false;
      setVoiceRecognition(false);
      return;
    }

    if (isIOS()) {
      if (silenceDetectionRef.current) {
        silenceDetectionRef.current.cleanup();
        silenceDetectionRef.current = null;
      }
      assameseRecordingRef.current = false;
      setIsAssameseRecording(false);
      setVoiceRecognition(false);
      recorder.cancelRecording();
      return;
    }

    // For other languages, just stop listening
    SpeechRecognition.stopListening();
    setVoiceRecognition(false);
  };

  const handleSendMessage = () => {
    if (input.trim() !== undefined && input.trim() !== "") {
      // Prevent API call if already loading
      if (loadingRef.current) {
        // console.log('⚠️ API call already in progress. Ignoring send message.');
        return;
      }
      setMessages([
        ...messages,
        { text: input, sender: "user", time: moment().format("h:mm A") },
      ]);

      apiCall(input, false, "text");
      setLoading(true);
      loadingRef.current = true;
      setInput("");
    }
  };

  //play audio
  const playAudio = (audioUrl: string, isGreetingAudio: boolean = false) => {
    if (!audioUrl) return;

    setAudioPlayFailed(null); // clear previous "audio not played" message on new attempt

    const audioElement: HTMLAudioElement | null = audioElementRef.current;

    if (audioElement) {
      audioElement.src = audioUrl;
      audioElement.load();
      isGreetingAudioRef.current = isGreetingAudio;

      // Use property handlers to avoid stacking multiple listeners
      audioElement.oncanplaythrough = () => {
        isIOS() && (audioElement.volume = 0.5);
        const playPromise = audioElement.play();
        if (playPromise !== undefined && typeof playPromise.then === "function") {
          playPromise
            .then(() => {
              setCurrentAudioUrl(audioUrl);
              setIsPlaying(true);
              setAudioPlayFailed(null);
            })
            .catch((err: unknown) => {
              const msg =
                "Audio could not play automatically (e.g. blocked by browser). Tap the play button to listen.";
              console.warn("[Audio] Audio is not played.", {
                reason: err,
                audioUrl: audioUrl.substring(0, 60) + "...",
                isGreetingAudio,
              });
              setAudioPlayFailed(msg);
            });
        } else {
          setCurrentAudioUrl(audioUrl);
          setIsPlaying(true);
        }
      };

    audioElement.onended = () => {
        // console.log('⏹️ Audio ended:', { 
        //   audioUrl, 
        //   isGreetingAudioRef: isGreetingAudioRef.current,
        //   currentMicBtn: micBtn,
        //   currentSendBtn: sendBtn,
        //   currentInputField: inputField
        // });

        // Handle delayed redirection
        if (redirectionUrlRef.current) {
          window.postMessage({
            type: "REDIRECTION",
            data: redirectionUrlRef.current,
          });
          // For browser testing - open in new tab
          // window.open(redirectionUrlRef.current, "_blank");
          // Clear the ref so we don't send multiple REDIRECTION messages
          redirectionUrlRef.current = null;
        }

        setIsPlaying(false);
        // If this was the greeting audio, activate the mic button
        if (isGreetingAudioRef.current) {
          // console.log('🎤 ACTIVATING MIC BUTTON - Greeting audio finished');
          setInputField(true);  // Ensure input field is visible
          setMicBtn(true);
          setSendBtn(false);
          isGreetingAudioRef.current = false;

          // Auto-start recognition after greeting on all platforms,
          // including iOS.
          startRecognition();
        } else if (shouldAutoMicAfterAudioRef.current) {
          // Auto-open mic after "Please describe your concern" response
          shouldAutoMicAfterAudioRef.current = false;
          setInputField(true);
          setMicBtn(true);
          setSendBtn(false);
          startRecognition();
        } else {
          // console.log('ℹ️ Not greeting audio, mic stays as is');
        }
      };
    }
  };

  // Pause audio
  const pauseAudio = () => {
    const audioElement: any = audioElementRef.current;
    audioElement !== null && audioElement.pause();
    setIsPlaying(false);
  };

  const apiCall = async (
    input: string,
    autoplay_: boolean,
    inputType: string
  ) => {
    setHideInput(false);
    setIsEnded(false);
    setInputField(true);
    setBackOptions(false);
    setAutoPlay(autoplay_);
    // Reset service category selection when making a new API call
    setSelectedServiceCategory(null);
    // Reset jobs context on each new API call; will be set from API response's nextContext
    setIsJobsContext(false);
    isJobsContextRef.current = false;
    // useSendQueryApi(input, selectedLanguage, inputType);
    await Api(input, selectedLanguage, inputType, (res: any) => {
      // Display query from response only when base64 was sent (iOS or Assamese)
      const sentBase64 = typeof input === "string" && input.startsWith("data:audio/");
      if (res.answer.query && inputType === "voice" && sentBase64) {
        setMessages((prevChats: any) => [
          ...prevChats,
          {
            text: res.answer.query,
            sender: "user",
            time: moment().format("h:mm A"),
          },
        ]);
        setVoiceRecognition(false);
      }

      if (res.answer.option) {
        // Support both array format and { list: [...] } format
        const optionsData = Array.isArray(res.answer.option)
          ? res.answer.option
          : res.answer.option?.list || [];

        // Check if it's a service list format and store it
        const isServiceListFormat =
          optionsData.length > 0 && optionsData[0].name !== undefined;

        if (isServiceListFormat) {
          setOriginalServiceList(optionsData);
          // Store nextContext (e.g. "=service_subcategory_") for subsequent selections
          const nextCtx = res.answer.nextContext || null;
          setServiceNextContext(nextCtx);
          serviceNextContextRef.current = nextCtx;
          // Determine jobs context from the API response's nextContext
          const jobsCtx = !!nextCtx && nextCtx.includes("job");
          setIsJobsContext(jobsCtx);
          isJobsContextRef.current = jobsCtx;

          // Check if the API returned subcategories within the first category
          // This happens when backend sends category with nested subcategories
          if (optionsData.length === 1 && optionsData[0].subcategories && optionsData[0].subcategories.length > 0) {
            // Automatically show the subcategories instead of the parent category
            setOptionList(optionsData[0].subcategories);
            setSelectedServiceCategory(optionsData[0]);
            setBackOptions(true);
          } else {
            // Show the main categories
            setOptionList(optionsData);
            setSelectedServiceCategory(null);
          }
        } else {
          // Regular options format
          setOptionList(optionsData);
          setServiceNextContext(null);
          serviceNextContextRef.current = null;
        }

        setHideInput(true);
        setInputField(false);
        setAutoPlay(false);
      }
      if (res.answer.response === "Please describe your concern") {
        setAutoInput(false);
        shouldAutoMicAfterAudioRef.current = true;
      } else {
        setAutoInput(true);
        shouldAutoMicAfterAudioRef.current = false;
      }
      setLoading(false);
      loadingRef.current = false;
      // setCount(count + 1);
      setMessages((prevChats: any) => [
        ...prevChats,
        {
          text: res.answer.response,
          sender: "bot",
          audio: res.answer.audio,
          options: res.answer.option,
          knowMore: res.answer.knowMore,
          end: res.answer.end,
          time: moment().format("h:mm A"),
          answerId: res.answer.answerId,
        },
      ]);

      playAudio(res.answer.audio);

      // Handle redirection URL (e.g., for survey buttons)
      if (res.answer.redirectionURL && res.answer.redirectionURL !== "") {
        console.log(res.answer.redirectionURL, "redirectionURL");

        // If there is audio, delay the redirection until audio ends
        if (res.answer.audio) {
          // console.log("Queueing redirection after audio");
          redirectionUrlRef.current = res.answer.redirectionURL;
        } else {
          // No audio - execute immediately
          // For mobile app integration
          window.postMessage({
            type: "REDIRECTION",
            data: res.answer.redirectionURL,
          });
          // For browser testing - open in new tab
          window.open(res.answer.redirectionURL, "_blank");
          redirectionUrlRef.current = null;
        }
      } else {
        // Clear any pending redirection if this response doesn't have one
        redirectionUrlRef.current = null;
      }

      if (
        res.answer.action &&
        (res.answer.action.includes("=grevLoc=") ||
          res.answer.action.includes("=hospLoc="))
      ) {
        setLocation(true);
        setInputField(false);
        setAutoPlay(false);
      }
      if (res.answer.action && res.answer.action.includes("=grevFile=")) {
        setFileUpload(true);
        setInputField(false);
        setAutoPlay(false);

        setMessages((prevChats: any) => [
          ...prevChats,
          {
            text: fileLimtWar[language],
            sender: "user",
            time: moment().format("h:mm A"),
          },
        ]);
      }

      if (res.answer.end) {
        setIsEnded(true);
      }

      if (res.answer && res.answer.hospital) {
        SetOptionsHeader((HospitalHeader as any)[selectedLanguage]);
      } else {
        SetOptionsHeader((OptionSelect as any)[selectedLanguage]);
      }
    });
  };

  const handleHospitalOption = (data: any) => {
    setHideInput(false);
    setInputField(false);
    setBackOptions(true);
    setHospitalView(true);
    setSearchTerm("");
    setHospitalData(data);
  };

  const handleOptionClick = (value: any, messageText?: string) => {
    // Check if it's a service list format (has 'name' property) or regular format (has 'label' property)
    const isServiceListFormat = value.name !== undefined;

    if (value.value && value.value.includes("hospital")) {
      handleHospitalOption(value);
    } else if (isServiceListFormat && value.subcategories && value.subcategories.length > 0) {
      // If it's a service category with subcategories, display them without API call
      // Don't add a message to chat - just show subcategories directly

      // Set the subcategories as the option list
      setOptionList(value.subcategories);
      setSelectedServiceCategory(value);
      setBackOptions(true);
      setHideInput(true);
      setInputField(false);
    } else {
      // Prevent API call if already loading
      if (loadingRef.current) {

        return;
      }

      // Determine display text and value based on format (messageText = e.g. spoken query to show in chat)
      const displayText = isServiceListFormat
        ? (value.name || value.en || "")
        : value.label;
      const textToShowInChat = messageText !== undefined && messageText.trim() !== "" ? messageText.trim() : displayText;

      let apiValue: string;

      // Read from refs to get the most up-to-date values (avoids stale closure issues)
      const currentIsJobsContext = isJobsContextRef.current;
      const currentServiceNextContext = serviceNextContextRef.current;

      // Check if we're in jobs context
      if (currentIsJobsContext && isServiceListFormat && value.id) {
        // For jobs: use =job_category_${value.id}_${name}_${en} format
        const jobName = (value.name || "").toString();
        const jobEn = (value.en || "").toString();
        apiValue = `=job_category_${value.id}_${jobName}_${jobEn}`;
      } else if (isServiceListFormat && selectedServiceCategory && value.id) {
        // For services: This is a subcategory - use nextContext from API if available,
        // and send both id and name (without spaces) in the format:
        // =service_subcategory_<id>_<NameWithoutSpaces>
        const subcategoryNameNoSpaces = (value.name || value.en || "")
          .toString()
          .replace(/\s+/g, "");
        if (currentServiceNextContext) {
          apiValue = `${currentServiceNextContext}${subcategoryNameNoSpaces}_${value.id}`;
        } else {
          apiValue = `=service_subcategory_${subcategoryNameNoSpaces}_${value.id}`;
        }
      } else if (isServiceListFormat) {
        // This is a main category without subcategories or regular service list item
        // For jobs context, use job format; otherwise use service format
        if (currentIsJobsContext && value.id) {
          const jobName = (value.name || "").toString();
          const jobEn = (value.en || "").toString();
          apiValue = `=job_category_${value.id}_${jobName}_${jobEn}`;
        } else {
          apiValue = value.id ? `=service_category_${value.id}=` : (value.name || value.en || "");
        }
      } else {
        // Regular format
        apiValue = value.value;
      }

      setMessages((prevChats: any) => [
        ...prevChats,
        {
          text: textToShowInChat,
          sender: "user",
          time: moment().format("h:mm A"),
        },
      ]);
      apiCall(apiValue, autoPlay, "text");
      setLoading(true);
      loadingRef.current = true;
    }
  };

  const handleBackToServiceList = () => {
    if (originalServiceList.length > 0) {
      setOptionList(originalServiceList);
      setSelectedServiceCategory(null);
      setBackOptions(false);
    }
  };

  const handleFileUpload = (event: any) => {
    const file = event.target.files[0];

    if (event.target.files[0].size / (1024 * 1024) < 5) {
      setFileUpload(false);
      setInputField(true);
      setAutoPlay(false);
      setBackOptions(false);

      setMessages((prevChats: any) => [
        ...prevChats,
        {
          text: file.name,
          sender: "user",
          time: moment().format("h:mm A"),
        },
      ]);

      FileUpload(file, selectedLanguage, (res: any) => {
        playAudio(res.answer.audio);
        setMessages((prevChats: any) => [
          ...prevChats,
          {
            text: res.answer.response,
            sender: "bot",
            audio: res.answer.audio,
            options: res.answer.option,
            time: moment().format("h:mm A"),
          },
        ]);
      });
    } else {
      setFileUpload(false);
      setInputField(true);
      setAutoPlay(false);
      setBackOptions(false);

      setMessages((prevChats: any) => [
        ...prevChats,
        {
          text: fileLimt[language],
          sender: "user",
          time: moment().format("h:mm A"),
        },
      ]);
    }
  };

  // Geolocation

  function getUserLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setInput(`${latitude},${longitude}`);
          setLocation(false);
          setInputField(true);
          // Do something with the latitude and longitude
        },
        (error) => {
          console.error("Error getting user location:", error);
          setLocation(false);
          setInputField(true);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      setLocation(false);
      setInputField(true);
    }
  }
  const handleLanguageChange = (val: any) => {
    setLanguageOptions(false);
    setSelectedLanguage(val);
  };

  // Map button IDs to their backend values
  const getBackendValue = (buttonId: string, displayText: string): string => {
    const buttonIdToBackendValue: Record<string, string> = {
      "113": "survey", // Take Survey button -> send "survey" to backend
      // Add other mappings here if needed
    };

    return buttonIdToBackendValue[buttonId] || displayText;
  };

  const handleSchemes = (val: any) => {
    // Prevent API call if already loading
    if (loadingRef.current) {

      return;
    }

    // Stop any playing audio (including greeting audio) when clicking a button
    pauseAudio();

    // Get the backend value (use "survey" for button 113, otherwise use display text)
    const backendValue = getBackendValue(val.id, val.val);

    setMessages((prevChats: any) => [
      ...prevChats,
      {
        text: val.val, // Display the UI text in chat
        sender: "user",
        time: moment().format("h:mm A"),
      },
    ]);

    apiCall(backendValue, autoPlay, "text"); // Send backend value to API

    setLoading(true);
    loadingRef.current = true;
  };

  const resetBot = () => {
    setMessages((prevChats: any) => [
      ...prevChats,

      {
        sender: "bot",
        text: `${translations[selectedLanguage].goodbye}`,
        content: (
          <>
            {schemeOptions &&
              schemeOptions !== undefined &&
              schemeOptions.map((val: any, index: any) => (
                <span key={index}>
                  <p className={index === 0 ? "schemesListFirst" : "schemesList"} onClick={() => handleSchemes(val)}>
                    {val.val}
                  </p>
                </span>
              ))}
          </>
        ),
        audio: shortAudio[selectedLanguage],
        time: moment().format("h:mm A"),
      },
    ]);
  };

  const searchInData = (searchTerm) => {
    if (autoSuggScheme === undefined || autoSuggScheme.length === 0) return [];
    const options = {
      keys: ["label"],
      threshold: 0.3,
    };
    const fuse = new Fuse(autoSuggScheme, options);
    const result = fuse.search(searchTerm);
    if (result.length > 0) return result[0].item.value;
    else return "";
  };
  /******************* Life Cycle ******************/

  useEffect(() => {
    if (isEnded && !isPlaying) {
      setAutoPlay(false);
      const mssgContent = setTimeout(() => {
        resetBot();
      }, 2500);

      return () => {
        clearTimeout(mssgContent);
      };
    }
  }, [isEnded, isPlaying]);

  useEffect(() => {
    console.log('🎤 Transcript updated:', { transcript });
    const delayDebounceFn = setTimeout(() => {
      // Only process if transcript exists, hasn't been processed before, and renderMic is true
      if (transcript && renderMic && transcript !== lastProcessedTranscriptRef.current) {
        console.log('inside the debounce setTimeout');
        // Mark this transcript as processed
        lastProcessedTranscriptRef.current = transcript;

        stopRecognition();
        setVoiceRecognition(false);
        setTranscriptTxt("");
        setInputField(true);
        if (!isIOS()) {
          // Prevent API call if already loading
          if (loadingRef.current) {

            return;
          }

          const data =
            searchInData(transcript).length > 0
              ? searchInData(transcript)
              : transcript;

          apiCall(data, false, "voice");
          setLoading(true);
          loadingRef.current = true;
          setMessages((prevChats: any) => [
            ...prevChats,
            {
              text: transcript,
              sender: "user",
              time: moment().format("h:mm A"),
            },
          ]);
        }

        // After we have consumed this transcript for an API call,
        // clear the underlying buffer so the next mic session
        // starts clean.
        // console.log(
        //   "🧹 [ChatContent] Clearing transcript AFTER processing. Current state:",
        //   { transcript, lastProcessedTranscript: lastProcessedTranscriptRef.current }
        // );
        try {
          resetTranscript();
          lastProcessedTranscriptRef.current = "";
        } catch (err) {
          console.error(
            "❌ [ChatContent] Error calling resetTranscript() after processing transcript:",
            err
          );
        }
        // console.log(
        //   "🧹 [ChatContent] Transcript cleared AFTER processing. New ref values:",
        //   { lastProcessedTranscript: lastProcessedTranscriptRef.current }
        // );
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [transcript]);

  useEffect(() => {
    if (chatMessageRef.current) {
      chatMessageRef.current.scrollTop = chatMessageRef.current.scrollHeight;
    }
  }, [messages, loading]);

  useEffect(() => {
    // Auto-start recognition after audio playback on all platforms
    if (!isEnded && autoPlay && !isPlaying) {
      startRecognition();
    }
  }, [isPlaying]);

  useEffect(() => {

    pauseAudio();
    if (input && input.length > 0) {
      // console.log('🔴 Input has text - Disabling mic, enabling send');
      setMicBtn(false);
      setSendBtn(true);
    } else {
      // console.log('🟢 Input is empty - Enabling mic, disabling send');
      setMicBtn(true);
      setSendBtn(false);
    }
  }, [input]);

  useEffect(() => {
    // console.log('🎤 Mic button state changed:', { micBtn, sendBtn, inputField });
  }, [micBtn, sendBtn]);

  useEffect(() => {
    // console.log('📥 InputField state changed:', { inputField });
  }, [inputField]);

  useEffect(() => {
    if (!active) {
      setTimeout(() => {
        setActive(true);
      }, 1000);
      return;
    }

    Lang(selectedLanguage);

    setMessages((prevChats: any) => [
      ...prevChats,
      {
        text: translations[selectedLanguage].greeting,
        sender: "bot",
        audio: audio[selectedLanguage],
        time: moment().format("h:mm A"),
      },

      {
        sender: "bot",
        text: `${translations[selectedLanguage].goodbye}`,
        content: (
          <>
            {schemeOptions &&
              schemeOptions !== undefined &&
              schemeOptions.map((val: any, index: any) => (
                <span key={index}>
                  <p className={index === 0 ? "schemesListFirst" : "schemesList"} onClick={() => handleSchemes(val)}>
                    {val.val}
                  </p>
                </span>
              ))}
          </>
        ),
        time: moment().format("h:mm A"),
        end: false,
      },
    ]);

    // When language changes, stop current audio (if any) and play the greeting audio for the new language
    pauseAudio();
    playAudio(audio[selectedLanguage], true);
  }, [selectedLanguage]);

  // useEffect(() => {
  //   RecommendSchemesApi(selectedLanguage, (res: any) => {
  //     res && res !== undefined && res.length > 0 && setAutoSuggScheme(res);
  //   });
  // }, [selectedLanguage]);

  // Track if initial setup is done
  const initialSetupDone = useRef(false);
  const urlLanguageInitialized = useRef(false);

  // Initialize language from URL only once on mount
  useEffect(() => {
    if (!urlLanguageInitialized.current) {
      const searchParams = new URLSearchParams(document.location.search);
      const language = searchParams.get("locale")
        ? searchParams.get("locale")
        : "en";
      language !== null && setSelectedLanguage(language);
      urlLanguageInitialized.current = true;
    }
  }, []);

  // Set up blur event listener only once
  useEffect(() => {
    window.addEventListener(
      "blur",
      function () {
        pauseAudio();
      },
      false
    );
  }, []);

  // Update button content when schemeOptions changes (when API data loads)
  useEffect(() => {
    const options = schemeOptions;

    // If messages already exist, just update the button content (don't change the text)
    if (initialSetupDone.current && messages.length > 0) {
      setMessages((prevMessages) => {
        const updatedMessages = [...prevMessages];
        // Find and update the message with button content
        const buttonMessageIndex = updatedMessages.findIndex(
          (msg) => msg.sender === "bot" && msg.content
        );
        if (buttonMessageIndex !== -1) {
          updatedMessages[buttonMessageIndex] = {
            ...updatedMessages[buttonMessageIndex],
            // Keep the existing text, only update the content (buttons)
            content: (
              <>
                {options &&
                  options.map((val: any, index: any) => (
                    <span key={index}>
                      <p className={index === 0 ? "schemesListFirst" : "schemesList"} onClick={() => handleSchemes(val)}>
                        {val.val}
                      </p>
                    </span>
                  ))}
              </>
            ),
          };
        }
        return updatedMessages;
      });
    } else if (!initialSetupDone.current) {
      // Initial setup - set messages for the first time
      const searchParams = new URLSearchParams(document.location.search);
      const language = searchParams.get("locale")
        ? searchParams.get("locale")
        : selectedLanguage;

      setMessages([
        {
          sender: "bot",
          text: `${translations[language].greeting}
       `,
          time: moment().format("h:mm A"),
          audio: audio[language],
        },
        {
          sender: "bot",
          text: `${translations[language].goodbye}`,
          content: (
            <>
              {options &&
                options.map((val: any, index: any) => (
                  <span key={index}>
                    <p className={index === 0 ? "schemesListFirst" : "schemesList"} onClick={() => handleSchemes(val)}>
                      {val.val}
                    </p>
                  </span>
                ))}
            </>
          ),
          time: moment().format("h:mm A"),
          // audio: greetingMessage(moment().format("HH:mm")).audio,
        },
      ]);
      initialSetupDone.current = true;
      playAudio(audio[language], true);
    }
  }, [schemeOptions]);

  useEffect(() => {
    transcript.length > 0 && setTranscriptTxt(transcript);
    // Only when using Speech Recognition (not Assamese-only); Assamese non-iOS uses recorder only
    const usingSpeechRecognition = !(selectedLanguage === "as" && !isIOS());
    if (!listening && voiceRecognition && usingSpeechRecognition) {
      playAudio(
        "https://coroverbackendstorage.blob.core.windows.net/chatbot-audio-bucket/caught.mp3"
      );
      SpeechRecognition.stopListening();
      if (isIOS()) recorder.saveRecording();
    }
  }, [transcript, listening]);

  return (
    <div style={{ position: "relative", height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Debug Logger - Bug Button */}
      {/*<DebugLogger />*/}

      {/* textMessages */}
      {/* {audioPlayFailed && (
        <div
          style={{
            padding: "8px 12px",
            margin: "0 10px 8px",
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: "6px",
            fontSize: "13px",
            color: "red",
          }}
          role="alert"
        >
          {audioPlayFailed}
        </div>
      )} */}
      <Messages
        chatMessageRef={chatMessageRef}
        audioElementRef={audioElementRef}
        messages={messages}
        selectedLanguage={selectedLanguage}
        currentAudioUrl={currentAudioUrl}
        isPlaying={isPlaying}
        pauseAudio={pauseAudio}
        playAudio={playAudio}
        loading={loading}
      />

      {/* options for selection */}
      <SchemesOptions
        hideInput={hideInput}
        selectedLanguage={selectedLanguage}
        optionList={optionList}
        setHideInput={setHideInput}
        setInputField={setInputField}
        handleOptionClick={handleOptionClick}
        setBackOptions={setBackOptions}
        backOptions={backOptions}
        optionHeader={optionHeader}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        recognitionSupported={true}
        pauseAudio={pauseAudio}
        setVoiceRecognition={setVoiceRecognition}
        SpeechRecognition={SpeechRecognition}
        setRenderMic={setRenderMic}
        renderMic={renderMic}
        selectedServiceCategory={selectedServiceCategory}
        handleBackToServiceList={handleBackToServiceList}
        isPlaying={isPlaying}
      />

      {/* voice popup */
      /* On iOS we don't use SpeechRecognition, so `listening` stays false.
         Show the popup whenever voiceRecognition is true on iOS, or when
         listening/isAssameseRecording is true on other platforms. */}
      {voiceRecognition && (isIOS() || listening || isAssameseRecording) && (
        <Voice
          setVoiceRecognition={setVoiceRecognition}
          setInputField={() => {
            !fileUpload ? setInputField(true) : setInputField(false);
          }}
          selectedLanguage={selectedLanguage}
          transcript={isIOS() ? "" : (isAssameseRecording ? (ListeningTrans as any)[selectedLanguage] : transcriptTxt)}
          setTranscriptTxt={setTranscriptTxt}
          stopRecognition={stopRecognition}
          cancelRecognition={cancelRecognition}
        />
      )}

      {/* language selections*/}
      <LanguageOptions
        languageOptions={languageOptions}
        setLanguageOptions={setLanguageOptions}
        handleLanguageChange={handleLanguageChange}
        selectedLanguage={selectedLanguage}
      />

      {/* Address Options */}

      <AutoSuggestions
        input={input}
        setInput={setInput}
        selectedLanguage={selectedLanguage}
        autoPlay={autoPlay}
        apiCall={apiCall}
        setLoading={setLoading}
        setMessages={setMessages}
        autoInput={autoInput}
        autoSuggScheme={autoSuggScheme}
        loadingRef={loadingRef}
      />

      <HospitalOptions
        HospitalView={HospitalView}
        HospitalData={HospitalData}
        setHospitalView={setHospitalView}
        selectedLanguage={selectedLanguage}
        setSearchTerm={setSearchTerm}
      />

      {/* MicAndTextfield language,input, mic */}
      <MicAndTextfield
        inputField={inputField}
        setLanguageOptions={setLanguageOptions}
        selectedLanguage={selectedLanguage}
        input={input}
        handleSendMessage={handleSendMessage}
        setInput={setInput}
        micBtn={micBtn}
        recognitionSupported={true}
        startRecognition={startRecognition}
        requestPermission={requestPermission}
        sendBtn={sendBtn}
        getUserLocation={getUserLocation}
        fileUpload={fileUpload}
        handleFileUpload={handleFileUpload}
        location={location}
        setBackOptions={setBackOptions}
        backOptions={backOptions}
        setHideInput={setHideInput}
        setInputField={setInputField}
        setHospitalView={setHospitalView}
        setSearchTerm={setSearchTerm}
        setFileUpload={setFileUpload}
        setAutoPlay={setAutoPlay}
        apiCall={apiCall}
        setMessages={setMessages}
        setLoading={setLoading}
        loadingRef={loadingRef}
      />
    </div>
  );
};

export default ChatContent;
